import React from 'react';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';

const apiDomain = process.env.REACT_APP_DOMAIN;

export default function Footer() {
  return (
    <div className='footer bg-dark py-4'>
        <Container>
            <div className="d-md-flex align-items-center justify-content-between">
                <p className="mb-md-0 mb-3 text-white">© PremierAgile Consulting Private Limited. All Rights Reserved.</p>
                <p className="mb-0"><Link to={`${apiDomain}/privacy-policy/`} target="_blank" className='bgs-grey px-4 py-1 text-dark br-30 d-inline-block'>Data Privacy</Link></p>
            </div>
        </Container>
    </div>
  )
}
